var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAudience(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 680,
    viewBox: "0 0 1024 680",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1033.54 -11.49H-21.8601V691.49H1033.54V-11.49Z",
    fill: "url(#paint0_radial_2_6623)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M928.25 61.47L1081.85 -36.35L-62.22 -38.55L93.16 61.47H928.25Z",
    fill: "#030E11"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M959.72 76.47H61.6799V588.59H959.72V76.47Z",
    fill: "url(#paint1_linear_2_6623)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M960.23 42.98V643.55L993.07 668.77V22.06L960.23 42.98Z",
    fill: "#10273A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M960.23 42.98L974.39 43.9L993.07 36.31V22.06L960.23 42.98Z",
    fill: "#060E14"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M974.39 43.9L973.65 553.86L993.07 571.21V33.42L974.39 43.9Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9999 42.98V643.55L30.1499 668.77V22.06L62.9999 42.98Z",
    fill: "#10273A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M491.64 643.11C491.95 642.42 475.84 632.93 476.81 606.99L476.99 582.19C475.41 566.89 487.51 555.72 501.33 555.72C525.44 555.72 528.59 571.12 528.33 586.72C527.89 613.48 532.79 633.62 532.79 643.12L491.64 643.11Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M112.19 652.55C111.88 651.86 127.99 642.37 127.02 616.43L126.84 591.63C128.42 576.33 119.61 563.44 100.51 565.16C80 567 73.57 581.32 73.83 596.9C74.28 623.66 71.05 643.05 71.05 652.55H112.19Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M356 640.6C356.31 639.91 340.19 630.42 341.17 604.48L341.34 579.68C339.77 564.38 353.34 549.6 367.68 553.21C389.18 549.6 394.61 569.37 394.35 584.95C393.91 611.72 397.14 631.1 397.14 640.6H356Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M242.83 643C242.52 642.3 258.63 632.82 257.66 606.88L255.66 569.36C264.08 562.7 249.98 546.93 231.18 550.36C207.59 554.67 205.86 571 206.12 586.58C206.56 613.35 201.67 633.49 201.67 642.99L242.83 643Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M255.68 569.39C246.79 566.09 254.35 588.53 251.1 591.22C249.1 592.91 257.19 594.96 257.7 590.98C258.38 585.68 257.82 574.2 255.68 569.39Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M251.94 588.53C248.47 579.44 238.23 583.32 243.35 592.37C248.47 601.42 255.91 596.54 251.94 588.53Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M750.64 572.19C749.21 582.81 749.93 600.34 749.93 600.34H763C763 600.34 767.85 576.2 750.64 572.19Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M758.15 581.67C749.26 577.36 748.85 572.19 752.37 566.76C757.07 559.5 772.26 547.54 789.86 556.76C816.81 570.96 803.43 603.11 803.43 603.11L759.54 611.16L758.15 581.67Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M920.35 642C920.66 641.31 904.68 631.91 905.65 606.19L905.82 581.6C904.26 566.43 914.82 555.35 928.55 555.35C952.45 555.35 956.98 570.63 956.73 586.08C956.28 612.61 936.04 637.27 936.04 646.69L920.35 642Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M907.61 569C906.081 567.46 904.92 565.594 904.215 563.542C903.51 561.49 903.279 559.304 903.54 557.15C903.54 557.15 907.83 561.64 911.11 560.77C910.509 559.46 910.247 558.02 910.346 556.582C910.446 555.145 910.904 553.755 911.68 552.54C911.68 552.54 912 556.63 920.02 557.28C928.04 557.93 907.61 569 907.61 569Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M907.61 569C909.36 571.59 911.02 574.29 910.01 586.1C909.83 588.19 906.11 589.25 905.6 586.1C904.93 581.89 905.49 572.8 907.61 569Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M294.35 725.94H167L173.84 602.58C173.838 601.784 173.919 600.99 174.08 600.21C174.625 597.581 176.059 595.22 178.141 593.524C180.222 591.828 182.825 590.902 185.51 590.9H275.89C278.988 590.9 281.959 592.131 284.149 594.321C286.339 596.511 287.57 599.482 287.57 602.58L294.35 725.94Z",
    fill: "url(#paint2_linear_2_6623)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M247.55 590.9C238.55 590.9 235.84 604.71 235.38 605.5H193.22C196.08 590.95 206.09 590.9 206.09 590.9L209.01 590.8C221.85 590.35 221.23 590.28 234.08 590.58L247.55 590.9Z",
    fill: "url(#paint3_linear_2_6623)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M280.76 725.94H167L173.84 602.58C173.838 601.784 173.919 600.99 174.08 600.21H262.82C265.915 600.21 268.883 601.44 271.072 603.628C273.26 605.817 274.49 608.785 274.49 611.88L280.76 725.94Z",
    fill: "url(#paint4_linear_2_6623)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M150 725.94H4.55005L11.39 602.58C11.3887 601.047 11.6896 599.528 12.2755 598.111C12.8614 596.694 13.7208 595.406 14.8046 594.322C15.8884 593.237 17.1753 592.376 18.5918 591.789C20.0083 591.202 21.5267 590.9 23.06 590.9H131.46C134.556 590.903 137.524 592.134 139.713 594.325C141.901 596.515 143.13 599.484 143.13 602.58L150 725.94Z",
    fill: "url(#paint5_linear_2_6623)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M118.25 590.9C109.25 590.9 106.54 604.71 106.08 605.5H63.9202C66.7802 590.95 76.7902 590.9 76.7902 590.9L79.7102 590.8C92.5502 590.35 91.9302 590.28 104.78 590.58L118.25 590.9Z",
    fill: "url(#paint6_linear_2_6623)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M139.19 725.94H4.55005L11.07 608.32C11.2171 606.134 12.1892 604.085 13.7896 602.589C15.39 601.093 17.4991 600.26 19.69 600.26H23.5401H121.2C124.295 600.26 127.263 601.489 129.452 603.678C131.641 605.867 132.87 608.835 132.87 611.93L139.19 725.94Z",
    fill: "url(#paint7_linear_2_6623)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.7 725.94H862.29L869.13 602.58C869.129 601.047 869.43 599.528 870.016 598.111C870.601 596.694 871.461 595.406 872.545 594.322C873.628 593.237 874.915 592.376 876.332 591.789C877.748 591.202 879.267 590.9 880.8 590.9H989.19C991.876 590.898 994.48 591.823 996.563 593.519C998.646 595.216 1000.08 597.579 1000.62 600.21C1000.79 600.989 1000.87 601.783 1000.87 602.58L1007.7 725.94Z",
    fill: "url(#paint8_linear_2_6623)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M922.32 590.9C931.32 590.9 934.03 604.71 934.49 605.5H976.65C973.79 590.95 963.78 590.9 963.78 590.9L960.86 590.8C948.02 590.35 948.64 590.28 935.79 590.58L922.32 590.9Z",
    fill: "url(#paint9_linear_2_6623)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.7 725.94H877L883.32 611.88C883.319 610.346 883.62 608.827 884.207 607.41C884.793 605.993 885.654 604.706 886.739 603.622C887.824 602.538 889.112 601.678 890.529 601.093C891.947 600.507 893.466 600.207 895 600.21H998.5C999.13 600.205 999.738 600.449 1000.19 600.889C1000.64 601.329 1000.9 601.93 1000.91 602.56L1007.7 725.94Z",
    fill: "url(#paint10_linear_2_6623)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M436 725.94H308.59L312.22 602.58C312.219 601.842 312.289 601.105 312.43 600.38C312.941 597.714 314.365 595.31 316.456 593.58C318.547 591.85 321.176 590.903 323.89 590.9H414.28C415.813 590.901 417.33 591.204 418.745 591.792C420.161 592.38 421.446 593.241 422.529 594.325C423.612 595.41 424.47 596.697 425.056 598.113C425.641 599.53 425.941 601.047 425.94 602.58L436 725.94Z",
    fill: "url(#paint11_linear_2_6623)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M390.23 590.9C381.23 590.9 378.52 604.71 378.06 605.5H335.9C338.76 590.95 348.77 590.9 348.77 590.9L351.69 590.8C364.53 590.35 363.91 590.28 376.76 590.58L390.23 590.9Z",
    fill: "url(#paint12_linear_2_6623)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M425.77 725.94H308.59L312.22 602.58C312.219 601.842 312.289 601.105 312.43 600.38C313.09 600.262 313.76 600.206 314.43 600.21H404.81C406.343 600.209 407.862 600.51 409.279 601.095C410.696 601.681 411.984 602.541 413.068 603.625C414.153 604.708 415.014 605.995 415.601 607.412C416.188 608.828 416.49 610.347 416.49 611.88L425.77 725.94Z",
    fill: "url(#paint13_linear_2_6623)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M703.19 725.94H575.8L585.19 602.58C585.19 599.482 586.42 596.511 588.611 594.321C590.801 592.131 593.772 590.9 596.87 590.9H687.25C689.948 590.9 692.563 591.835 694.65 593.545C696.738 595.255 698.168 597.635 698.7 600.28C698.844 601.038 698.918 601.808 698.92 602.58L703.19 725.94Z",
    fill: "url(#paint14_linear_2_6623)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M703.19 725.94H586L595.29 611.88C595.29 610.344 595.593 608.823 596.182 607.405C596.771 605.986 597.634 604.698 598.722 603.614C599.81 602.53 601.101 601.671 602.522 601.087C603.942 600.503 605.464 600.205 607 600.21H697.39C697.838 600.208 698.285 600.232 698.73 600.28C698.874 601.038 698.948 601.808 698.95 602.58L703.19 725.94Z",
    fill: "url(#paint15_linear_2_6623)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M716.79 725.94H844.19L837.35 602.58C837.351 601.047 837.05 599.529 836.464 598.113C835.878 596.696 835.019 595.409 833.935 594.325C832.851 593.241 831.564 592.382 830.148 591.796C828.731 591.21 827.213 590.909 825.68 590.91H735.3C733.767 590.909 732.249 591.21 730.833 591.796C729.416 592.382 728.129 593.241 727.045 594.325C725.961 595.409 725.102 596.696 724.516 598.113C723.93 599.529 723.629 601.047 723.63 602.58L716.79 725.94Z",
    fill: "url(#paint16_linear_2_6623)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M765.31 590.9C774.31 590.9 777.02 604.71 777.48 605.5H819.64C816.77 590.95 806.76 590.9 806.76 590.9L803.84 590.8C791 590.35 791.62 590.28 778.78 590.58L765.31 590.9Z",
    fill: "url(#paint17_linear_2_6623)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M569.27 725.94H441.87L448.71 602.58C448.709 601.047 449.01 599.528 449.596 598.111C450.181 596.694 451.041 595.406 452.125 594.322C453.208 593.237 454.495 592.376 455.912 591.789C457.328 591.202 458.847 590.9 460.38 590.9H550.76C552.294 590.9 553.812 591.202 555.228 591.789C556.645 592.376 557.932 593.237 559.016 594.322C560.099 595.406 560.959 596.694 561.545 598.111C562.131 599.528 562.431 601.047 562.43 602.58L569.27 725.94Z",
    fill: "url(#paint18_linear_2_6623)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M533.13 590.75C533.06 590.75 494.07 590.29 483.13 590.75C474.68 590.75 468.46 604.68 468.13 605.32H542C541.65 604.68 536.88 590.75 533.13 590.75Z",
    fill: "url(#paint19_linear_2_6623)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M568.76 725.94H442.39L448.71 611.88C448.709 610.347 449.01 608.829 449.596 607.413C450.182 605.996 451.041 604.709 452.125 603.625C453.209 602.541 454.496 601.682 455.913 601.096C457.329 600.51 458.847 600.209 460.38 600.21H550.76C552.293 600.209 553.811 600.51 555.228 601.096C556.644 601.682 557.931 602.541 559.015 603.625C560.099 604.709 560.958 605.996 561.544 607.413C562.131 608.829 562.431 610.347 562.43 611.88L568.76 725.94Z",
    fill: "url(#paint20_linear_2_6623)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M730.38 725.94H844.19L837.35 602.58C837.352 601.784 837.271 600.99 837.11 600.21H748.37C746.838 600.21 745.321 600.512 743.905 601.099C742.49 601.685 741.204 602.545 740.121 603.629C739.039 604.712 738.18 605.999 737.595 607.415C737.009 608.831 736.709 610.348 736.71 611.88L730.38 725.94Z",
    fill: "url(#paint21_linear_2_6623)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M535.08 679.52C534.69 678.64 555.08 666.63 553.87 633.78L553.64 602.37C555.64 582.98 540.31 568.83 522.81 568.83C492.28 568.83 488.29 588.35 488.62 608.08C489.18 641.98 482.98 667.49 482.98 679.52H535.08Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M658.39 683.07C658.78 682.19 638.39 670.18 639.61 637.33L642.12 589.8C629.05 580.4 642.39 567.47 666.21 569.2C683.12 570.42 694.84 574.66 696.56 587.01C706.8 597.35 700.73 607.44 700.56 616.22C700 650.12 710.48 671.04 710.48 683.07H658.39Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M642.12 589.8C645.49 592.44 642.85 613.8 644.96 615.26C647.07 616.72 639.85 618.68 639.21 614.66C638.35 609.29 639.4 594.67 642.12 589.8Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M645.92 614.66C648.29 606.35 654.92 609.5 652.5 616.83C650.08 624.16 645.92 614.66 645.92 614.66Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M851.45 675.89C851.84 675.01 831.45 662.99 832.67 630.14L835.18 582.62C824.51 574.19 842.37 554.22 866.18 558.62C896.06 564.08 898.25 584.76 897.92 604.5C897.36 638.39 903.56 663.91 903.56 675.94L851.45 675.89Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M836.87 582.38C854.11 578.1 868.49 588.7 870.06 604.95C871.63 621.2 836.87 609 836.87 609V582.38Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M835.18 582.62C841.18 580.73 841.81 594.97 840.52 610.05C840.29 612.73 832.4 613.99 831.76 609.97C830.9 604.61 832.46 587.49 835.18 582.62Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M177.3 591.22C178.91 601.17 178.1 617.59 178.1 617.59H163.4C163.4 617.59 157.91 595 177.3 591.22Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M166.66 603.07C176.31 597.44 173.99 593.58 173.21 586.36C172.21 577.49 153.37 566.31 131.88 578.72C110.39 591.13 117.48 631.28 117.48 631.28L167.27 636.49L166.66 603.07Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M170.89 584.31C185.76 590.59 181.07 603.71 181.07 603.71L175.07 604.38L170.19 592.26L170.89 584.31Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M214.27 725.94H56.5601L63.4001 624C63.4004 622.186 63.7396 620.389 64.4001 618.7C65.4685 615.909 67.3587 613.507 69.8208 611.813C72.283 610.118 75.2012 609.211 78.1901 609.21H192.65C196.573 609.21 200.335 610.768 203.108 613.542C205.882 616.316 207.44 620.077 207.44 624L214.27 725.94Z",
    fill: "url(#paint22_linear_2_6623)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M170.87 609.18C161.87 609.18 159.16 622.99 158.7 623.77H96.7C97.11 623.06 96.21 609.21 115.99 609.18L118.9 609.08C131.753 608.627 144.6 608.553 157.44 608.86L170.87 609.18Z",
    fill: "url(#paint23_linear_2_6623)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M202.7 725.94H56.5601L63.4001 624C63.3975 623.148 63.4711 622.298 63.6201 621.46C63.7756 620.622 64.218 619.864 64.8712 619.317C65.5244 618.77 66.3478 618.467 67.2001 618.46H181.71C185.63 618.46 189.389 620.017 192.161 622.789C194.933 625.561 196.49 629.32 196.49 633.24L202.7 725.94Z",
    fill: "url(#paint24_linear_2_6623)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2201 725.94H-5.66992V609.17H32.6001C34.5457 609.17 36.4722 609.554 38.2692 610.3C40.0662 611.045 41.6985 612.138 43.0724 613.516C44.4463 614.894 45.5348 616.529 46.2758 618.328C47.0167 620.127 47.3953 622.054 47.3901 624L54.2201 725.94Z",
    fill: "url(#paint25_linear_2_6623)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0901 725.94H-5.66992V618.38H19.0801C23 618.38 26.7593 619.937 29.5311 622.709C32.3029 625.481 33.8601 629.24 33.8601 633.16L40.0901 725.94Z",
    fill: "url(#paint26_linear_2_6623)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.75 609.17V725.94H960L966.83 623.94C966.83 615.78 973.45 609.15 985.61 609.15L1024.75 609.17Z",
    fill: "url(#paint27_linear_2_6623)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.25 618.38V725.94H971.25L977.48 633.16C977.48 629.24 979.037 625.481 981.809 622.709C984.581 619.937 988.34 618.38 992.26 618.38H1024.25Z",
    fill: "url(#paint28_linear_2_6623)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M415 725.94H243.4L247.67 623.94C247.668 622.342 247.928 620.754 248.44 619.24C249.423 616.304 251.303 613.75 253.815 611.94C256.327 610.129 259.344 609.153 262.44 609.15H390.79C392.737 609.15 394.666 609.535 396.464 610.282C398.262 611.029 399.895 612.123 401.27 613.503C402.644 614.883 403.732 616.52 404.472 618.322C405.211 620.123 405.588 622.053 405.58 624L415 725.94Z",
    fill: "url(#paint29_linear_2_6623)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M405.15 725.94H243.4L247.67 623.94V623.89C247.693 622.429 248.285 621.034 249.319 620.002C250.353 618.97 251.749 618.381 253.21 618.36H381.81C385.73 618.36 389.489 619.917 392.261 622.689C395.033 625.461 396.59 629.22 396.59 633.14L405.15 725.94Z",
    fill: "url(#paint30_linear_2_6623)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M798.58 725.94H956.29L949.45 623.94C949.45 620.02 947.893 616.261 945.121 613.489C942.349 610.717 938.59 609.16 934.67 609.16H820.19C818.244 609.16 816.317 609.544 814.52 610.291C812.723 611.037 811.091 612.131 809.718 613.51C808.345 614.889 807.257 616.525 806.518 618.326C805.779 620.126 805.402 622.054 805.41 624L798.58 725.94Z",
    fill: "url(#paint31_linear_2_6623)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M840.6 609.18C849.6 609.18 852.31 622.99 852.77 623.77H914.77C914.36 623.06 915.26 609.21 895.49 609.18L892.57 609.08C879.723 608.627 866.877 608.553 854.03 608.86L840.6 609.18Z",
    fill: "url(#paint32_linear_2_6623)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M810.14 725.94H956.29L949.45 623.94C949.448 623.089 949.374 622.239 949.23 621.4C949.075 620.562 948.632 619.804 947.979 619.257C947.326 618.71 946.502 618.407 945.65 618.4H831.14C827.22 618.4 823.461 619.957 820.689 622.729C817.917 625.501 816.36 629.26 816.36 633.18L810.14 725.94Z",
    fill: "url(#paint33_linear_2_6623)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M597.87 725.94H755.58L751.31 623.94C751.31 620.02 749.753 616.261 746.981 613.489C744.209 610.717 740.45 609.16 736.53 609.16H622.05C620.104 609.16 618.177 609.544 616.38 610.291C614.583 611.037 612.951 612.131 611.578 613.51C610.205 614.889 609.117 616.525 608.378 618.326C607.639 620.126 607.262 622.054 607.27 624L597.87 725.94Z",
    fill: "url(#paint34_linear_2_6623)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M642.8 609.18C651.8 609.18 654.51 622.99 654.97 623.77H716.97C716.56 623.06 717.46 609.21 697.69 609.18L694.77 609.08C681.93 608.627 669.084 608.553 656.23 608.86L642.8 609.18Z",
    fill: "url(#paint35_linear_2_6623)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M585.28 725.94H427.57L434.41 623.94C434.41 620.019 435.967 616.259 438.738 613.485C441.51 610.712 445.269 609.153 449.19 609.15H563.66C565.607 609.151 567.534 609.537 569.331 610.284C571.128 611.032 572.76 612.127 574.133 613.507C575.506 614.886 576.593 616.523 577.332 618.324C578.072 620.125 578.448 622.054 578.44 624L585.28 725.94Z",
    fill: "url(#paint36_linear_2_6623)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M553.35 609.16C553.26 609.16 495.93 608.73 481.84 609.16C477.02 609.16 470.26 623.09 469.84 623.73H564.6C564.24 623.12 558.17 609.16 553.35 609.16Z",
    fill: "url(#paint37_linear_2_6623)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M584.66 725.94H428.18L434.41 633.16C434.41 629.24 435.967 625.481 438.739 622.709C441.511 619.937 445.27 618.38 449.19 618.38H563.66C567.58 618.38 571.339 619.937 574.111 622.709C576.883 625.481 578.44 629.24 578.44 633.16L584.66 725.94Z",
    fill: "url(#paint38_linear_2_6623)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M607.3 725.94H755.58L751.31 623.94V623.89C751.287 622.429 750.695 621.034 749.661 620.002C748.627 618.97 747.231 618.381 745.77 618.36H630.64C626.72 618.36 622.961 619.917 620.189 622.689C617.417 625.461 615.86 629.22 615.86 633.14L607.3 725.94Z",
    fill: "url(#paint39_linear_2_6623)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M499.62 722.66C500.08 721.66 475.87 704.59 477.34 665.66L477.6 628.4C477.6 604.98 493.41 588.62 514.17 588.62C550.39 588.62 555.17 611.77 554.74 635.18C554.07 675.39 561.43 708.43 561.43 722.7L499.62 722.66Z",
    fill: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M711.76 715.93C712.23 714.93 688.02 700.64 689.48 661.67L689.75 624.41C687.37 601.41 707.75 579.21 729.31 584.63C761.61 579.21 769.78 608.91 769.39 632.33C768.72 672.53 773.57 701.66 773.57 715.93H711.76Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M337.55 710.41C337.09 709.41 354.74 701.67 353.28 662.7L353.81 618.88C354.53 611.88 358.34 605.13 356.81 599.6C355.13 593.6 347.9 589 343.7 585.4C339 581.4 332.78 579.1 325.14 579.1C288.92 579.1 282.05 602.25 282.44 625.66C283.11 665.87 275.75 696.13 275.75 710.41H337.55Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M356.86 599.77C360.5 595.89 364.2 589.48 363.02 581.77C363.02 581.77 356.53 588.58 351.56 587.26C352.469 585.275 352.866 583.094 352.716 580.916C352.566 578.738 351.873 576.632 350.7 574.79C350.7 574.79 350.21 580.98 338.05 581.97C325.89 582.96 356.86 599.77 356.86 599.77Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M356.86 599.77C349.24 599.77 354.21 626.9 351.86 628.62C346.96 632.24 359.95 674.62 359.86 625.68C359.89 619.23 360.08 605.54 356.86 599.77Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M352.88 628.6C347.97 612.03 342.28 631.6 346.88 638.71C351.48 645.82 353.3 636.16 353.3 632.93C353.39 631.474 353.248 630.012 352.88 628.6Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M101.32 715.58C100.85 714.53 125.07 700.28 123.6 661.31L120.6 604.94C133.26 594.94 112 582.87 88.87 584.27C52.72 586.47 45.79 607.42 46.18 630.83C46.85 671.04 39.49 701.3 39.49 715.58H101.32Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M120.62 604.94C112.75 606.63 111.62 615.94 113.17 633.84C113.44 637.01 123.31 638.61 124.07 633.84C125.09 627.47 123.84 610.72 120.62 604.94Z",
    fill: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M905 600.81C902.85 613.32 903.93 633.97 903.93 633.97H923.5C923.5 633.97 930.81 605.53 905 600.81Z",
    fill: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M916.23 615.05C902.88 608.58 901.74 596.76 905.4 587.76C908.84 579.28 929.55 565.27 959.29 579.5C989.03 593.73 984.29 647.34 984.29 647.34L918.35 659.44L916.23 615.05Z",
    fill: "black"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M169.78 630.16C168.188 629.661 166.529 629.408 164.86 629.41H4.23999V636.35H168.92C172.44 636.35 173.16 631.2 169.78 630.16Z",
    fill: "url(#paint40_linear_2_6623)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1030.66 630C1029.2 629.59 1027.68 629.381 1026.16 629.38H870.84C869.172 629.378 867.512 629.631 865.92 630.13C862.54 631.13 863.26 636.32 866.78 636.32H1026.17C1027.68 636.324 1029.19 636.509 1030.66 636.87V630Z",
    fill: "url(#paint41_linear_2_6623)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M197.08 722.66H4.23999V629.42H172.71C175.016 629.42 177.3 629.875 179.43 630.759C181.56 631.643 183.495 632.939 185.123 634.572C186.752 636.205 188.042 638.144 188.92 640.276C189.798 642.409 190.247 644.694 190.24 647L197.08 722.66Z",
    fill: "url(#paint42_radial_2_6623)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M405.06 722.66H204.06L210.91 647V646.91C210.931 642.274 212.789 637.835 216.077 634.566C219.364 631.297 223.814 629.465 228.45 629.47H380.69C385.339 629.47 389.798 631.317 393.086 634.604C396.373 637.892 398.22 642.351 398.22 647L405.06 722.66Z",
    fill: "url(#paint43_radial_2_6623)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M1030.66 630.09V722.66H838.66L845.46 647C845.452 644.693 845.9 642.406 846.778 640.272C847.657 638.138 848.948 636.199 850.577 634.566C852.207 632.932 854.144 631.637 856.276 630.754C858.407 629.871 860.693 629.417 863 629.42H1025.86C1027.48 629.418 1029.1 629.643 1030.66 630.09Z",
    fill: "url(#paint44_radial_2_6623)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M831.63 722.66H630.63L637.48 647C637.473 644.695 637.922 642.41 638.799 640.279C639.676 638.147 640.966 636.209 642.593 634.576C644.22 632.943 646.154 631.647 648.283 630.762C650.412 629.877 652.694 629.421 655 629.42H807.26C811.894 629.42 816.339 631.255 819.624 634.523C822.909 637.791 824.766 642.226 824.79 646.86V647L831.63 722.66Z",
    fill: "url(#paint45_radial_2_6623)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M610.12 722.66H425.58L432.42 647C432.414 644.69 432.864 642.401 433.745 640.265C434.626 638.129 435.921 636.188 437.554 634.554C439.188 632.921 441.129 631.626 443.265 630.745C445.401 629.864 447.69 629.413 450 629.42H585.8C588.102 629.427 590.38 629.886 592.505 630.774C594.629 631.661 596.558 632.957 598.181 634.59C599.804 636.222 601.09 638.158 601.965 640.288C602.84 642.417 603.287 644.698 603.28 647L610.12 722.66Z",
    fill: "url(#paint46_radial_2_6623)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M348.38 629.42H348.12C328.46 629.42 323.45 643.23 322.66 644.01H260.61C261.33 643.29 266.26 629.44 286.04 629.42L317.14 629.18L348.38 629.42Z",
    fill: "url(#paint47_linear_2_6623)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M552.49 629.44C552.4 629.44 495.12 628.98 481.03 629.44C476.22 629.44 469.45 643.37 469.03 644.01H563.79C563.43 643.37 557.31 629.44 552.49 629.44Z",
    fill: "url(#paint48_linear_2_6623)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M111.68 629.42H111.42C91.76 629.44 86.75 643.23 86 644H17.5C18.21 643.28 23.14 629.43 42.93 629.41L75.45 629.17L111.68 629.42Z",
    fill: "url(#paint49_linear_2_6623)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M920.5 629.42H920.75C940.42 629.42 945.43 643.23 946.22 644.01H1008.22C1007.51 643.29 1002.58 629.44 982.79 629.42L951.69 629.18L920.5 629.42Z",
    fill: "url(#paint50_linear_2_6623)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M183.05 722.66H4.23999V642.89H159.88C164.529 642.89 168.988 644.737 172.276 648.024C175.563 651.312 177.41 655.771 177.41 660.42L183.05 722.66Z",
    fill: "url(#paint51_linear_2_6623)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M397.44 722.66H204.07L210.29 653.79C210.53 650.857 211.851 648.118 213.996 646.104C216.141 644.09 218.958 642.945 221.9 642.89H374.27C376.573 642.889 378.854 643.341 380.982 644.221C383.11 645.102 385.043 646.393 386.672 648.021C388.301 649.649 389.593 651.582 390.475 653.709C391.356 655.837 391.81 658.117 391.81 660.42L397.44 722.66Z",
    fill: "url(#paint52_linear_2_6623)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M700.84 629.42H701.1C720.76 629.42 725.77 643.23 726.56 644.01H788.61C787.89 643.29 782.97 629.44 763.18 629.42L732.08 629.18L700.84 629.42Z",
    fill: "url(#paint53_linear_2_6623)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M1030.66 642.89V722.66H852.66L858.29 660.42C858.29 655.771 860.137 651.312 863.425 648.024C866.712 644.737 871.171 642.89 875.82 642.89H1030.66Z",
    fill: "url(#paint54_linear_2_6623)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M831.63 722.66H638.26L643.9 660.42C643.898 658.118 644.351 655.837 645.231 653.71C646.112 651.583 647.403 649.65 649.031 648.021C650.659 646.393 652.592 645.102 654.72 644.222C656.847 643.341 659.127 642.889 661.43 642.89H813.8C816.74 642.944 819.556 644.088 821.701 646.1C823.846 648.112 825.167 650.849 825.41 653.78L831.63 722.66Z",
    fill: "url(#paint55_linear_2_6623)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M610.2 722.66H425.51L431.14 660.42C431.139 658.118 431.591 655.837 432.472 653.71C433.352 651.583 434.643 649.65 436.271 648.021C437.9 646.393 439.833 645.102 441.96 644.222C444.087 643.341 446.368 642.889 448.67 642.89H587C591.649 642.89 596.108 644.737 599.396 648.024C602.683 651.312 604.53 655.771 604.53 660.42L610.2 722.66Z",
    fill: "url(#paint56_linear_2_6623)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9999 42.98L48.8399 43.9L30.1499 36.31V21.56L62.9999 42.98Z",
    fill: "#060E14"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8399 43.9L49.5799 553.86L30.1499 570.08V33.42L48.8399 43.9Z",
    fill: "black"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M983.36 201.02C987.894 201.02 991.57 188.117 991.57 172.2C991.57 156.283 987.894 143.38 983.36 143.38C978.826 143.38 975.15 156.283 975.15 172.2C975.15 188.117 978.826 201.02 983.36 201.02Z",
    fill: "url(#paint57_radial_2_6623)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M983.58 149.71C988.114 149.71 991.79 136.807 991.79 120.89C991.79 104.973 988.114 92.07 983.58 92.07C979.046 92.07 975.37 104.973 975.37 120.89C975.37 136.807 979.046 149.71 983.58 149.71Z",
    fill: "url(#paint58_radial_2_6623)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M40.22 201.33C44.7543 201.33 48.43 188.427 48.43 172.51C48.43 156.593 44.7543 143.69 40.22 143.69C35.6858 143.69 32.01 156.593 32.01 172.51C32.01 188.427 35.6858 201.33 40.22 201.33Z",
    fill: "url(#paint59_radial_2_6623)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M40.44 150.03C44.9742 150.03 48.65 137.127 48.65 121.21C48.65 105.293 44.9742 92.39 40.44 92.39C35.9057 92.39 32.23 105.293 32.23 121.21C32.23 137.127 35.9057 150.03 40.44 150.03Z",
    fill: "url(#paint60_radial_2_6623)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M976.65 160.26H990.6V133.69H976.65V160.26Z",
    fill: "#10273A"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M983.62 134.77C987.469 134.77 990.59 134.34 990.59 133.81C990.59 133.28 987.469 132.85 983.62 132.85C979.77 132.85 976.65 133.28 976.65 133.81C976.65 134.34 979.77 134.77 983.62 134.77Z",
    fill: "#10273A"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M984.59 132.85V159.32H982.23V132.87L984.59 132.85Z",
    fill: "#183C54"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M983.62 161.32C987.453 161.32 990.56 160.872 990.56 160.32C990.56 159.768 987.453 159.32 983.62 159.32C979.787 159.32 976.68 159.768 976.68 160.32C976.68 160.872 979.787 161.32 983.62 161.32Z",
    fill: "#CDC752"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8901 159.76H46.8401V133.19H32.8901V159.76Z",
    fill: "#10273A"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8699 134.27C43.7193 134.27 46.8399 133.84 46.8399 133.31C46.8399 132.78 43.7193 132.35 39.8699 132.35C36.0205 132.35 32.8999 132.78 32.8999 133.31C32.8999 133.84 36.0205 134.27 39.8699 134.27Z",
    fill: "#10273A"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M40.83 132.35V158.82H38.47V132.37L40.83 132.35Z",
    fill: "#183C54"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8699 160.82C43.7028 160.82 46.8099 160.372 46.8099 159.82C46.8099 159.268 43.7028 158.82 39.8699 158.82C36.0371 158.82 32.9299 159.268 32.9299 159.82C32.9299 160.372 36.0371 160.82 39.8699 160.82Z",
    fill: "#CDC752"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M140.25 32.98C148.987 32.98 156.07 30.5355 156.07 27.52C156.07 24.5045 148.987 22.06 140.25 22.06C131.513 22.06 124.43 24.5045 124.43 27.52C124.43 30.5355 131.513 32.98 140.25 32.98Z",
    fill: "#10273A"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M154 24.8C154 24.8 151.08 27.52 140.29 27.52C129.5 27.52 126.59 24.8 126.59 24.8C126.59 24.8 131.59 22.06 140.29 22.06C148.99 22.06 154 24.8 154 24.8Z",
    fill: "#C3BD51"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M516.09 32.98C524.827 32.98 531.91 30.5355 531.91 27.52C531.91 24.5045 524.827 22.06 516.09 22.06C507.353 22.06 500.27 24.5045 500.27 27.52C500.27 30.5355 507.353 32.98 516.09 32.98Z",
    fill: "#10273A"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M529.8 24.8C529.8 24.8 526.88 27.52 516.09 27.52C505.3 27.52 502.39 24.8 502.39 24.8C502.39 24.8 507.39 22.06 516.09 22.06C524.79 22.06 529.8 24.8 529.8 24.8Z",
    fill: "#C3BD51"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M881.71 32.98C890.447 32.98 897.53 30.5355 897.53 27.52C897.53 24.5045 890.447 22.06 881.71 22.06C872.973 22.06 865.89 24.5045 865.89 27.52C865.89 30.5355 872.973 32.98 881.71 32.98Z",
    fill: "#10273A"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M895.41 24.8C895.41 24.8 893 27.52 882.21 27.52C871.42 27.52 868 24.8 868 24.8C868 24.8 873 22.06 881.71 22.06C890.42 22.06 895.41 24.8 895.41 24.8Z",
    fill: "#C3BD51"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M753.3 574.67C757.144 574.67 760.26 571.554 760.26 567.71C760.26 563.866 757.144 560.75 753.3 560.75C749.456 560.75 746.34 563.866 746.34 567.71C746.34 571.554 749.456 574.67 753.3 574.67Z",
    fill: "#050505"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M753.55 563.52C757.256 563.52 760.26 561.071 760.26 558.05C760.26 555.029 757.256 552.58 753.55 552.58C749.844 552.58 746.84 555.029 746.84 558.05C746.84 561.071 749.844 563.52 753.55 563.52Z",
    fill: "#050505"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M762.21 559.62C766.258 559.62 769.54 556.338 769.54 552.29C769.54 548.242 766.258 544.96 762.21 544.96C758.162 544.96 754.88 548.242 754.88 552.29C754.88 556.338 758.162 559.62 762.21 559.62Z",
    fill: "#050505"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M772.04 555.83C775.172 555.83 777.71 553.291 777.71 550.16C777.71 547.029 775.172 544.49 772.04 544.49C768.909 544.49 766.37 547.029 766.37 550.16C766.37 553.291 768.909 555.83 772.04 555.83Z",
    fill: "#050505"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M779.01 555.35C781.876 555.35 784.2 553.026 784.2 550.16C784.2 547.294 781.876 544.97 779.01 544.97C776.143 544.97 773.82 547.294 773.82 550.16C773.82 553.026 776.143 555.35 779.01 555.35Z",
    fill: "#050505"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M785.68 557.48C788.547 557.48 790.87 555.156 790.87 552.29C790.87 549.424 788.547 547.1 785.68 547.1C782.814 547.1 780.49 549.424 780.49 552.29C780.49 555.156 782.814 557.48 785.68 557.48Z",
    fill: "#050505"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M791.65 560.82C794.516 560.82 796.84 558.496 796.84 555.63C796.84 552.764 794.516 550.44 791.65 550.44C788.784 550.44 786.46 552.764 786.46 555.63C786.46 558.496 788.784 560.82 791.65 560.82Z",
    fill: "#050505"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M796.07 563.53C798.936 563.53 801.26 561.206 801.26 558.34C801.26 555.474 798.936 553.15 796.07 553.15C793.204 553.15 790.88 555.474 790.88 558.34C790.88 561.206 793.204 563.53 796.07 563.53Z",
    fill: "#050505"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M797.58 566.02C800.446 566.02 802.77 563.696 802.77 560.83C802.77 557.964 800.446 555.64 797.58 555.64C794.714 555.64 792.39 557.964 792.39 560.83C792.39 563.696 794.714 566.02 797.58 566.02Z",
    fill: "#050505"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M799.71 571.21C802.576 571.21 804.9 568.886 804.9 566.02C804.9 563.154 802.576 560.83 799.71 560.83C796.844 560.83 794.52 563.154 794.52 566.02C794.52 568.886 796.844 571.21 799.71 571.21Z",
    fill: "#050505"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M801.85 576.4C804.717 576.4 807.04 574.076 807.04 571.21C807.04 568.344 804.717 566.02 801.85 566.02C798.984 566.02 796.66 568.344 796.66 571.21C796.66 574.076 798.984 576.4 801.85 576.4Z",
    fill: "#050505"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M802.77 579.86C805.636 579.86 807.96 577.536 807.96 574.67C807.96 571.804 805.636 569.48 802.77 569.48C799.904 569.48 797.58 571.804 797.58 574.67C797.58 577.536 799.904 579.86 802.77 579.86Z",
    fill: "#050505"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M177.83 603.96C180.487 603.96 182.64 601.807 182.64 599.15C182.64 596.494 180.487 594.34 177.83 594.34C175.174 594.34 173.02 596.494 173.02 599.15C173.02 601.807 175.174 603.96 177.83 603.96Z",
    fill: "black"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M179.8 598.08C182.456 598.08 184.61 595.927 184.61 593.27C184.61 590.614 182.456 588.46 179.8 588.46C177.143 588.46 174.99 590.614 174.99 593.27C174.99 595.927 177.143 598.08 179.8 598.08Z",
    fill: "black"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M179.8 593.28C182.456 593.28 184.61 591.126 184.61 588.47C184.61 585.813 182.456 583.66 179.8 583.66C177.143 583.66 174.99 585.813 174.99 588.47C174.99 591.126 177.143 593.28 179.8 593.28Z",
    fill: "black"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M179.14 588.16C181.797 588.16 183.95 586.006 183.95 583.35C183.95 580.693 181.797 578.54 179.14 578.54C176.484 578.54 174.33 580.693 174.33 583.35C174.33 586.006 176.484 588.16 179.14 588.16Z",
    fill: "black"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M179.14 582.59C181.797 582.59 183.95 580.437 183.95 577.78C183.95 575.124 181.797 572.97 179.14 572.97C176.484 572.97 174.33 575.124 174.33 577.78C174.33 580.437 176.484 582.59 179.14 582.59Z",
    fill: "black"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M177.3 578.24C179.956 578.24 182.11 576.086 182.11 573.43C182.11 570.774 179.956 568.62 177.3 568.62C174.643 568.62 172.49 570.774 172.49 573.43C172.49 576.086 174.643 578.24 177.3 578.24Z",
    fill: "black"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M172.14 576.31C174.797 576.31 176.95 574.156 176.95 571.5C176.95 568.844 174.797 566.69 172.14 566.69C169.484 566.69 167.33 568.844 167.33 571.5C167.33 574.156 169.484 576.31 172.14 576.31Z",
    fill: "black"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M166.95 574.62C169.606 574.62 171.76 572.466 171.76 569.81C171.76 567.154 169.606 565 166.95 565C164.293 565 162.14 567.154 162.14 569.81C162.14 572.466 164.293 574.62 166.95 574.62Z",
    fill: "black"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M160.06 573.43C162.716 573.43 164.87 571.276 164.87 568.62C164.87 565.964 162.716 563.81 160.06 563.81C157.404 563.81 155.25 565.964 155.25 568.62C155.25 571.276 157.404 573.43 160.06 573.43Z",
    fill: "black"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M155.25 573.43C157.906 573.43 160.06 571.276 160.06 568.62C160.06 565.964 157.906 563.81 155.25 563.81C152.593 563.81 150.44 565.964 150.44 568.62C150.44 571.276 152.593 573.43 155.25 573.43Z",
    fill: "black"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M122.61 595.4C125.267 595.4 127.42 593.247 127.42 590.59C127.42 587.934 125.267 585.78 122.61 585.78C119.954 585.78 117.8 587.934 117.8 590.59C117.8 593.247 119.954 595.4 122.61 595.4Z",
    fill: "black"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M121.64 600.2C124.297 600.2 126.45 598.047 126.45 595.39C126.45 592.734 124.297 590.58 121.64 590.58C118.984 590.58 116.83 592.734 116.83 595.39C116.83 598.047 118.984 600.2 121.64 600.2Z",
    fill: "black"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M120.93 605.01C123.587 605.01 125.74 602.857 125.74 600.2C125.74 597.544 123.587 595.39 120.93 595.39C118.274 595.39 116.12 597.544 116.12 600.2C116.12 602.857 118.274 605.01 120.93 605.01Z",
    fill: "black"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M144.6 573.43C147.257 573.43 149.41 571.276 149.41 568.62C149.41 565.964 147.257 563.81 144.6 563.81C141.944 563.81 139.79 565.964 139.79 568.62C139.79 571.276 141.944 573.43 144.6 573.43Z",
    fill: "black"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M149.97 573.43C152.626 573.43 154.78 571.276 154.78 568.62C154.78 565.964 152.626 563.81 149.97 563.81C147.313 563.81 145.16 565.964 145.16 568.62C145.16 571.276 147.313 573.43 149.97 573.43Z",
    fill: "black"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M139.84 574.89C142.497 574.89 144.65 572.737 144.65 570.08C144.65 567.424 142.497 565.27 139.84 565.27C137.184 565.27 135.03 567.424 135.03 570.08C135.03 572.737 137.184 574.89 139.84 574.89Z",
    fill: "black"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M134.36 581.17C139.126 581.17 142.99 578.126 142.99 574.37C142.99 570.614 139.126 567.57 134.36 567.57C129.594 567.57 125.73 570.614 125.73 574.37C125.73 578.126 129.594 581.17 134.36 581.17Z",
    fill: "black"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M132.34 584.58C137.106 584.58 140.97 581.536 140.97 577.78C140.97 574.024 137.106 570.98 132.34 570.98C127.574 570.98 123.71 574.024 123.71 577.78C123.71 581.536 127.574 584.58 132.34 584.58Z",
    fill: "black"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M157.37 592.15C170.078 592.15 180.38 587.149 180.38 580.98C180.38 574.811 170.078 569.81 157.37 569.81C144.662 569.81 134.36 574.811 134.36 580.98C134.36 587.149 144.662 592.15 157.37 592.15Z",
    fill: "black"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M320.1 32.98C328.837 32.98 335.92 30.5355 335.92 27.52C335.92 24.5045 328.837 22.06 320.1 22.06C311.363 22.06 304.28 24.5045 304.28 27.52C304.28 30.5355 311.363 32.98 320.1 32.98Z",
    fill: "#10273A"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M333.8 24.8C333.8 24.8 330.89 27.52 320.1 27.52C309.31 27.52 306.39 24.8 306.39 24.8C306.39 24.8 311.39 22.06 320.1 22.06C328.81 22.06 333.8 24.8 333.8 24.8Z",
    fill: "#C3BD51"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M695.57 32.98C704.307 32.98 711.39 30.5355 711.39 27.52C711.39 24.5045 704.307 22.06 695.57 22.06C686.833 22.06 679.75 24.5045 679.75 27.52C679.75 30.5355 686.833 32.98 695.57 32.98Z",
    fill: "#10273A"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7599 -20.35C-5.10005 -44.25 -75.3801 -111.52 -54.0901 -131C-32.8001 -150.48 25.7999 -72.52 47.66 -48.62C69.52 -24.72 133.37 31.16 112.08 50.63C90.7899 70.1 38.6199 3.55 16.7599 -20.35Z",
    fill: "url(#paint61_radial_2_6623)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M709.27 24.8C709.27 24.8 706.36 27.52 695.57 27.52C684.78 27.52 681.86 24.8 681.86 24.8C681.86 24.8 686.86 22.06 695.57 22.06C704.28 22.06 709.27 24.8 709.27 24.8Z",
    fill: "#C3BD51"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M836.57 -54.21C847.94 -84.54 888 -173.17 861 -183.3C834 -193.43 808.7 -99.24 797.33 -68.91C785.96 -38.58 747.57 37.09 774.59 47.21C801.61 57.33 825.19 -23.88 836.57 -54.21Z",
    fill: "url(#paint62_radial_2_6623)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M998.14 -13.73C1020.5 -37.17 1092.14 -102.97 1071.27 -122.88C1050.4 -142.79 990.19 -66.08 967.83 -42.64C945.47 -19.2 880.49 35.36 901.37 55.26C922.25 75.16 975.78 9.71001 998.14 -13.73Z",
    fill: "url(#paint63_radial_2_6623)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M914 43.9C920.17 37.38 926.55 31.05 933 24.76C936.21 21.61 939.47 18.52 942.73 15.43C945.99 12.34 949.27 9.28001 952.56 6.22001L957.5 1.64001L962.5 -2.85999C965.85 -5.85999 969.19 -8.85999 972.6 -11.79C976.01 -14.72 979.36 -17.71 982.8 -20.6L993.12 -29.28C996.58 -32.14 1000.12 -34.91 1003.63 -37.73L1008.9 -41.92L1014.26 -46.02L1019.61 -50.12C1021.39 -51.49 1023.17 -52.86 1025.01 -54.12C1028.64 -56.7867 1032.29 -59.4133 1035.95 -62C1039.61 -64.6 1043.39 -67 1047.11 -69.57C1048.98 -70.82 1050.83 -72.09 1052.72 -73.31L1058.45 -76.87L1064.19 -80.39L1067.07 -82.15L1070.07 -83.78C1073.99 -85.9733 1077.93 -88.1367 1081.88 -90.27C1078.04 -87.9367 1074.19 -85.6233 1070.34 -83.33L1067.45 -81.6L1064.64 -79.75L1059 -76.08L1053.37 -72.42C1051.51 -71.16 1049.69 -69.85 1047.85 -68.56C1044.19 -65.97 1040.48 -63.46 1036.85 -60.79C1022.36 -50.22 1008.23 -39.15 994.4 -27.74C980.57 -16.33 967 -4.57999 953.59 7.35001C950.24 10.35 946.88 13.35 943.59 16.35C940.3 19.35 936.96 22.35 933.68 25.45C927 31.52 920.53 37.7 914 43.9Z",
    fill: "#43D5ED"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M780.49 40.58C783.29 32.64 786.2 24.75 789.06 16.83L797.82 -6.84001C803.68 -22.61 809.7 -38.32 815.64 -54.07C821.73 -69.76 827.73 -85.48 833.9 -101.13L843.18 -124.61C846.34 -132.41 849.44 -140.23 852.66 -148.01C849.86 -140.07 846.95 -132.17 844.09 -124.26L835.33 -100.58C829.47 -84.81 823.45 -69.1 817.51 -53.36C811.41 -37.67 805.41 -21.95 799.25 -6.29001L790 17.18C786.81 25 783.71 32.8 780.49 40.58Z",
    fill: "#43D5ED"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M645.66 -65.23C651.22 -97.14 674.22 -191.66 645.8 -196.61C617.38 -201.56 610 -104.33 604.4 -72.42C598.8 -40.51 575.13 41 603.55 45.91C631.97 50.82 640.1 -33.32 645.66 -65.23Z",
    fill: "url(#paint64_radial_2_6623)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M385.61 -50.7C377.21 -81.99 345.82 -174.06 373.68 -181.55C401.54 -189.04 417.68 -92.85 426.06 -61.55C434.44 -30.25 465.4 48.72 437.53 56.2C409.66 63.68 394 -19.42 385.61 -50.7Z",
    fill: "url(#paint65_radial_2_6623)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M606.3 43.6C607.41 35.45 608.64 27.32 609.81 19.19L613.53 -5.18001C616.04 -21.43 618.71 -37.64 621.3 -53.87C624.04 -70.08 626.69 -86.3 629.51 -102.49L633.78 -126.77C635.28 -134.85 636.71 -142.95 638.26 -151.02C637.16 -142.87 635.92 -134.75 634.75 -126.61L631 -102.24C628.5 -86 625.82 -69.78 623.24 -53.55C620.49 -37.35 617.84 -21.13 615.02 -4.93001L610.75 19.35C609.28 27.43 607.85 35.52 606.3 43.6Z",
    fill: "#43D5ED"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M158.76 -25.53C140.1 -52 78.9101 -127.64 102.49 -144.26C126.07 -160.88 174.33 -76.14 192.99 -49.66C211.65 -23.18 267.91 40.34 244.33 56.95C220.75 73.56 177.43 0.939987 158.76 -25.53Z",
    fill: "url(#paint66_radial_2_6623)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M430.22 37.3C427.91 29.78 425.72 22.22 423.46 14.68L416.9 -8C412.55 -23.13 408.37 -38.3 404.1 -53.45C399.83 -68.6 395.78 -83.8 391.74 -99L385.74 -121.83C383.8 -129.46 381.8 -137.07 379.92 -144.72C382.24 -137.19 384.43 -129.63 386.68 -122.09L393.24 -99.41C397.57 -84.3 401.75 -69.13 406 -54C410.25 -38.87 414.32 -23.64 418.36 -8.42999L424.36 14.4C426.34 22.05 428.34 29.66 430.22 37.3Z",
    fill: "#43D5ED"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M230.36 41.85C223.81 33.38 217.36 24.85 210.87 16.34L191.54 -9.28999C178.68 -26.39 166 -43.6 153.15 -60.74C140.3 -77.88 127.74 -95.18 115.15 -112.47L96.2801 -138.47C90.0401 -147.17 83.7501 -155.83 77.5701 -164.56C84.1201 -156.1 90.5701 -147.56 97.0601 -139.06L116.39 -113.43C129.25 -96.33 141.98 -79.12 154.78 -61.97C167.58 -44.82 180.19 -27.54 192.78 -10.24L211.66 15.76C217.89 24.46 224.17 33.11 230.36 41.85Z",
    fill: "#43D5ED"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M100.66 43.79C93.82 36.33 87 28.88 80.07 21.51C73.14 14.14 66.26 6.73999 59.27 -0.570007C52.28 -7.88 45.27 -15.18 38.27 -22.41C31.27 -29.64 24 -36.79 16.84 -43.88C9.67999 -50.97 2.41 -58 -4.94 -65C-12.29 -72 -19.81 -78.64 -27.38 -85.33C-34.95 -92.02 -42.75 -98.44 -50.81 -104.52C-58.767 -110.747 -67.2833 -116.223 -76.25 -120.88L-72.83 -119.25C-71.68 -118.72 -70.53 -118.18 -69.44 -117.54C-67.24 -116.3 -64.99 -115.12 -62.87 -113.74C-60.75 -112.36 -58.55 -111.08 -56.47 -109.63C-54.39 -108.18 -52.26 -106.82 -50.23 -105.31C-42 -99.37 -34.1 -93 -26.37 -86.5C-10.92 -73.4 3.78 -59.5 18.24 -45.3C32.7 -31.1 46.66 -16.48 60.39 -1.62001C67.25 5.81999 74.05 13.3133 80.79 20.86C87.47 28.45 94.16 36 100.66 43.79Z",
    fill: "#43D5ED"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M18.28 542.04L-38.49 580.77L-44.79 19.46L18.5 59.43L18.28 542.04Z",
    stroke: "#43D5ED",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M1006.13 538.58L1062.9 577.31L1069.19 16L1005.91 55.97L1006.13 538.58Z",
    stroke: "#43D5ED",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2_6623",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.855 239.39) scale(640.011 335.54)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A6981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#124859"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#09242C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001822"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_6623",
    x1: 509.29,
    y1: 95.41,
    x2: 510.68,
    y2: 328.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737C8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#98A1AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#BAC3C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D3DBDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E2EAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7EFED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_6623",
    x1: 230.65,
    y1: 467.23,
    x2: 230.65,
    y2: 732.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C53622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_6623",
    x1: 258.834,
    y1: 644.61,
    x2: 258.834,
    y2: 570.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#771C1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#67171C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3E0919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_6623",
    x1: 223.86,
    y1: 485.06,
    x2: 223.86,
    y2: 731.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C53622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#88221E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#50101A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#2D0418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_6623",
    x1: 77.26,
    y1: 467.23,
    x2: 77.26,
    y2: 732.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C53622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_6623",
    x1: 129.534,
    y1: 644.61,
    x2: 129.534,
    y2: 570.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#771C1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#67171C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3E0919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2_6623",
    x1: 71.87,
    y1: 485.06,
    x2: 71.87,
    y2: 731.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C53622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#88221E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#50101A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#2D0418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2_6623",
    x1: 934.99,
    y1: 467.23,
    x2: 934.99,
    y2: 732.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C53622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2_6623",
    x1: 911.036,
    y1: 644.61,
    x2: 911.036,
    y2: 570.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#771C1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#67171C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3E0919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2_6623",
    x1: 942.33,
    y1: 485.06,
    x2: 942.33,
    y2: 731.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C53622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#88221E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#50101A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#2D0418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2_6623",
    x1: 372.29,
    y1: 467.23,
    x2: 372.29,
    y2: 732.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C53622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2_6623",
    x1: 401.514,
    y1: 644.61,
    x2: 401.514,
    y2: 570.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#771C1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#67171C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3E0919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2_6623",
    x1: 367.18,
    y1: 485.06,
    x2: 367.18,
    y2: 731.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C53622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#88221E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#50101A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#2D0418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2_6623",
    x1: 639.49,
    y1: 467.23,
    x2: 639.49,
    y2: 732.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C53622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2_6623",
    x1: 644.6,
    y1: 485.06,
    x2: 644.6,
    y2: 731.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C53622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#88221E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#50101A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#2D0418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2_6623",
    x1: 780.49,
    y1: 467.24,
    x2: 780.49,
    y2: 732.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C53622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2_6623",
    x1: 754.026,
    y1: 644.61,
    x2: 754.026,
    y2: 570.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#771C1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#67171C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3E0919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2_6623",
    x1: 505.57,
    y1: 467.23,
    x2: 505.57,
    y2: 732.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C53622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2_6623",
    x1: 505.04,
    y1: 643.6,
    x2: 505.04,
    y2: 570.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#771C1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#67171C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3E0919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2_6623",
    x1: 505.57,
    y1: 485.06,
    x2: 505.57,
    y2: 731.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C53622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#88221E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#50101A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#2D0418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2_6623",
    x1: 787.29,
    y1: 485.06,
    x2: 787.29,
    y2: 731.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C53622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#88221E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#50101A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#2D0418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2_6623",
    x1: 135.41,
    y1: 569.71,
    x2: 135.41,
    y2: 721.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C53622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2_6623",
    x1: 172.25,
    y1: 662.88,
    x2: 172.25,
    y2: 588.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#771C1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#67171C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3E0919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2_6623",
    x1: 129.63,
    y1: 501.41,
    x2: 129.63,
    y2: 720.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#C53622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#A72C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5C141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2_6623",
    x1: 24.2801,
    y1: 569.71,
    x2: 24.2801,
    y2: 721.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C53622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2_6623",
    x1: 17.2101,
    y1: 501.41,
    x2: 17.2101,
    y2: 720.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#C53622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#A72C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5C141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2_6623",
    x1: 992.39,
    y1: 569.71,
    x2: 992.39,
    y2: 721.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C53622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2_6623",
    x1: 997.73,
    y1: 501.41,
    x2: 997.73,
    y2: 720.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#C53622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#A72C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5C141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2_6623",
    x1: 329.19,
    y1: 569.71,
    x2: 329.19,
    y2: 721.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C53622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2_6623",
    x1: 324.28,
    y1: 501.41,
    x2: 324.28,
    y2: 720.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#C53622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#A72C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5C141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2_6623",
    x1: 877.43,
    y1: 569.71,
    x2: 877.43,
    y2: 721.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C53622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2_6623",
    x1: 839.23,
    y1: 662.88,
    x2: 839.23,
    y2: 588.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#771C1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#67171C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3E0919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2_6623",
    x1: 883.22,
    y1: 501.41,
    x2: 883.22,
    y2: 720.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#C53622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#A72C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5C141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2_6623",
    x1: 676.72,
    y1: 569.71,
    x2: 676.72,
    y2: 721.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C53622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2_6623",
    x1: 641.43,
    y1: 662.88,
    x2: 641.43,
    y2: 588.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#771C1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#67171C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3E0919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2_6623",
    x1: 506.42,
    y1: 569.71,
    x2: 506.42,
    y2: 721.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C53622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2_6623",
    x1: 517.25,
    y1: 662.06,
    x2: 517.25,
    y2: 589.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#771C1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#67171C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3E0919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2_6623",
    x1: 506.42,
    y1: 501.41,
    x2: 506.42,
    y2: 720.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#C53622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#A72C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5C141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2_6623",
    x1: 681.44,
    y1: 501.41,
    x2: 681.44,
    y2: 720.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#C53622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#A72C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5C141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2_6623",
    x1: 88.1,
    y1: 597.56,
    x2: 88.1,
    y2: 733.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E94822"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2_6623",
    x1: 947.19,
    y1: 597.56,
    x2: 947.19,
    y2: 733.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E94822"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_2_6623",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.52 676.04) scale(192.78 192.78)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#C53622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#64161C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_2_6623",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(238.76 676.04) scale(200.3 200.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#C53622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#64161C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_2_6623",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(871.76 676.04) scale(192.04 192.04)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#C53622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#64161C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_2_6623",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(665.33 676.04) scale(200.29 200.29)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#C53622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#64161C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_2_6623",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(457.43 676.04) scale(185.15 185.15)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#C53622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#64161C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2_6623",
    x1: 323.783,
    y1: 682.43,
    x2: 323.783,
    y2: 609.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#771C1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#67171C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3E0919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2_6623",
    x1: 516.44,
    y1: 682.29,
    x2: 516.44,
    y2: 609.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#771C1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#67171C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3E0919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2_6623",
    x1: 83.8734,
    y1: 682.43,
    x2: 83.8734,
    y2: 609.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#771C1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#67171C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3E0919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2_6623",
    x1: 945.097,
    y1: 682.43,
    x2: 945.097,
    y2: 609.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#771C1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#67171C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3E0919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2_6623",
    x1: 93.64,
    y1: 571.02,
    x2: 93.64,
    y2: 738.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#7D1A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F040E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2_6623",
    x1: 300.75,
    y1: 571.02,
    x2: 300.75,
    y2: 738.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#7D1A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F040E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2_6623",
    x1: 725.446,
    y1: 682.43,
    x2: 725.446,
    y2: 609.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#771C1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#67171C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3E0919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#200017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2_6623",
    x1: 941.66,
    y1: 571.02,
    x2: 941.66,
    y2: 738.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#7D1A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F040E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2_6623",
    x1: 734.95,
    y1: 571.02,
    x2: 734.95,
    y2: 738.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#7D1A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F040E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2_6623",
    x1: 517.85,
    y1: 571.02,
    x2: 517.85,
    y2: 738.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#7D1A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F040E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_2_6623",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(984.176 171.785) rotate(90.18) scale(22.62 8.82179)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#9B9942"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#656831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#3B4123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#1C2519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0A1413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#030E11"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_2_6623",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(980.13 121.292) rotate(-89.82) scale(22.62 8.82179)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#9B9942"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#656831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#3B4123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#1C2519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0A1413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#030E11"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_2_6623",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.0177 172.099) rotate(90.18) scale(22.62 8.8218)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#9B9942"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#656831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#3B4123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#1C2519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0A1413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#030E11"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_2_6623",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.9679 121.606) rotate(-89.82) scale(22.62 8.8218)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#9B9942"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#656831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#3B4123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#1C2519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0A1413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#030E11"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_2_6623",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.4515 -34.9424) rotate(-132.221) scale(93.9837 8.23705)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43D5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#42D0E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#319EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#23727F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#184E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#0F3239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#081E23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#041215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#030E11"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_2_6623",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(822.179 -67.449) rotate(-69.8142) scale(93.3808 8.14791)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43D5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#42D0E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#319EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#23727F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#184E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#0F3239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#081E23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#041215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#030E11"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_2_6623",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(983.715 -26.8643) rotate(-46.6683) scale(93.913 8.22557)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43D5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#42D0E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#319EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#23727F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#184E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#0F3239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#081E23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#041215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#030E11"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_2_6623",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(631.068 -69.459) rotate(-80.5377) scale(94.0809 7.84007)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43D5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#42D0E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#319EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#23727F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#184E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#0F3239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#081E23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#041215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#030E11"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_2_6623",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(413.22 -70.1276) rotate(-105.186) scale(93.4875 8.13862)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43D5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#42D0E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#319EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#23727F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#184E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#0F3239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#081E23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#041215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#030E11"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_2_6623",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.353 -35.4824) rotate(-124.992) scale(94.3982 8.23608)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43D5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#42D0E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#319EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#23727F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#184E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#0F3239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#081E23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#041215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#030E11"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudience);
export default __webpack_public_path__ + "static/media/audience.905d97be797f1a17021302216adee9ca.svg";
export { ForwardRef as ReactComponent };